import Client from './Client';

export default class CouponClient {
  constructor() {
    this.client = Client;
  }

  /**
   *
   * 优惠券列表
   */
  async couponPage(data) {
    const res = await this.client.post('/api/coupon/page', data);
    return res;
  }

  /**
   * 优惠券列表-新增修改
   *
   */

  async couponUpsert(data) {
    const res = await this.client.post('/api/coupon/upsert', data);
    return res;
  }

  /**
   * 优惠券列表-修改状态
   *
   */

  async couponUpdateValid(data) {
    const res = await this.client.post('/api/coupon/updateValid', data);
    return res;
  }

  /**
   * 行业列表-获取详情
   *
   */

  async evaluationgetDetail(data) {
    const res = await this.client.post('/api/evaluation/getDetail', data);
    return res;
  }
  /**
   * 优惠券-下拉选择
   *
   */

  async couponSelect(data) {
    const res = await this.client.post('/api/coupon/select', data);
    return res;
  }
  /**
   * 用户优惠券查询
   *
   */

  async userCouponPage(data) {
    const res = await this.client.post('/api/user/coupon/page', data);
    return res;
  }
  /**
   * 添加优惠券
   *
   */

  async userCouponInsert(data) {
    const res = await this.client.post('/api/user/coupon/insert', data);
    return res;
  }
  /**
   * 删除优惠券
   *
   */

  async userCouponDelete(data) {
    const res = await this.client.post('//api/user/coupon/delete', data);
    return res;
  }
}